import 'react-day-picker/src/style.css';

import React from 'react';
import { DayPicker } from 'react-day-picker';

import { clampDateToBounds } from './dateBounds';
import type { DatePickerProps } from './types';

export const DatePicker = ({
    value,
    onChange,
    minimumDate,
    maximumDate,
}: DatePickerProps) => {
    const boundedValue = clampDateToBounds(value, minimumDate, maximumDate);

    return (
        <DayPicker
            mode="single"
            captionLayout="dropdown"
            fromYear={(minimumDate ?? new Date()).getFullYear() - 100}
            toYear={(maximumDate ?? new Date()).getFullYear()}
            disabled={(date) =>
                (maximumDate != null && date > maximumDate) ||
                (minimumDate != null && date < minimumDate)
            }
            selected={boundedValue}
            defaultMonth={boundedValue} // ensures picker opens to correct month, otherwise always 'current' month of new Date()
            onSelect={(date) => {
                if (date != null) {
                    onChange(clampDateToBounds(date, minimumDate, maximumDate));
                }
            }}
        />
    );
};
